<template>
  <div v-loading="loading">
    <el-form ref="form" :model="form" label-width="250px" @submit.prevent="onSubmit" style="margin: 20px; width: 60%; min-width: 600px">
      <el-form-item label="Enabled">
        <el-checkbox v-model="form.enabled"></el-checkbox>
      </el-form-item>
      <el-form-item label="Set Point (°F)">
        <el-input v-model="form.setPoint"></el-input>
      </el-form-item>
      <el-form-item label="Deadband (°F)">
        <el-input v-model="form.deadband"></el-input>
      </el-form-item>
      <el-form-item label="Valve Adjustment (-% of Target Position)">
        <el-input v-model="form.valveAdjustment"></el-input>
      </el-form-item>
      <el-form-item style="margin-top: 10px">
        <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"
import constants from "@/common/constants/system"

export default {
  data() {
    return {
      loading: false,
      form: {
        enabled: false,
        setPoint: "",
        deadband: "",
        valveAdjustment: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      user: this.$session.get("User")
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    verifySettings() {
      if (isNaN(parseInt(this.form.setPoint)) || parseInt(this.form.setPoint) < 0 || parseInt(this.form.setPoint) > 220) {
        const h = this.$createElement
        this.$notify({
          title: "Setpoint",
          message: "Value not valid.  Value should be between 0 and 220",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.deadband)) || parseInt(this.form.deadband) < 0 || parseInt(this.form.deadband) > 50) {
        const h = this.$createElement
        this.$notify({
          title: "Deadband",
          message: "Value not valid.  Value should be between 0 and 50",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.form.valveAdjustment)) || parseInt(this.form.valveAdjustment) < 0 || parseInt(this.form.valveAdjustment) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Valve Adjustment",
          message: "Value not valid.  Value should be between 0 and 100",
          type: "error"
        })
        return false
      }
      return true
    },
    saveDataToPanel() {
      if (!this.verifySettings()) return
      this.loading = true
      Axios.all([
        SettingsService.changeSetting(this.user.activeZone, "Settings.ReturnLine.Enabled", this.form.enabled ? "true" : "false"),
        SettingsService.changeSetting(this.user.activeZone, "Settings.ReturnLine.Setpoint", this.form.setPoint),
        SettingsService.changeSetting(this.user.activeZone, "Settings.ReturnLine.Adjustment", this.form.valveAdjustment),
        SettingsService.changeSetting(this.user.activeZone, "Settings.ReturnLine.Deadband", this.form.deadband)
      ])
        .then(
          Axios.spread((enabledResponse, setPointResponse, valveAdjustmentResponse, deadbandResponse) => {
            //The system should update in 10 seconds.
            this.loading = false
            if (
              enabledResponse.data.result != "success" ||
              setPointResponse.data.result != "success" ||
              valveAdjustmentResponse.data.result != "success" ||
              deadbandResponse.data.result != "success"
            ) {
              const h = this.$createElement
              this.$notify({
                title: "Return Line",
                message: "Error trying to save data to panel",
                type: "error"
              })
            } else {
              this.$notify({
                title: "Return Line",
                message: "Settings Saved to Panel",
                type: "info"
              })
            }
          })
        )
        .catch(() => {
          this.loading = false
          const h = this.$createElement
          this.$notify({
            title: "Return Line",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    },
    getData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((settingsResponse) => {
          this.form.enabled = settingsResponse.data.returnLine.enabled == "true"
          this.form.setPoint = settingsResponse.data.returnLine.setpoint
          this.form.deadband = settingsResponse.data.returnLine.deadband
          this.form.valveAdjustment = settingsResponse.data.returnLine.adjustment
        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}
/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// ReturnLine.vue?2bed00b0